import React from 'react';
import './App.css';
import { attributeLanguages } from './enums';

function Attributes(props: any) {

  function createAttributes() {
    var arr: any[] = [];
    for (let [key, attr] of Object.entries(attributeLanguages)) {
      const attrArr = attr.split(",")
      if (props.info[attrArr[0]] === true) {
        if (attrArr[0] === "CPP") {
          attrArr[0] = "C++";
        }

        var filterString = "drop-shadow(0px 0px 0.1rem " + attrArr[1] + ")"
        var temp = React.createElement(
          "p",
          {
            className: "attribute",
            key: key,
            style: {
              backgroundColor: attrArr[1],
              filter: filterString
            },
          },
          attrArr[0] as string
        )
        arr.push(temp);
      }
    }

    var e = React.createElement("div",
      { className: 'attributeBox' },
      arr
    );

    return (e);
  }

  return (
    createAttributes()
  );
}

export default Attributes;
